var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "side-bar": ["columns"],
                  "cache-overflow-size": 0,
                  "multi-sort-key": "ctrl",
                  "get-child-count": _vm.getChildCount,
                  "get-context-menu-items": _vm.getContextMenuItems,
                  modules: _vm.modules,
                },
                on: { "grid-ready": _vm.gridReady },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }